import { Card, IconButton, Typography } from "@mui/material";
import React from "react";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { useDocTransmittalContext } from "../DocTransmittal.context";

export default function SelectedFileCard({ file }) {
  const { files, setFiles } = useDocTransmittalContext();

  const onRemove = () => {
    setFiles(files.filter((f) => f.name !== file.name));
  };
  return (
    <Card
      sx={{
        p: 1,
        width: "300px",
        m: 1,
      }}
    >
      <InsertDriveFileIcon
        sx={{
          color: "primary.main",
          transform: "translateY(5px)",
          mr: 0.5,
        }}
      />
      <Typography sx={{ display: "inline-block", lineHeight: 1.2 }}>
        {file.name}
      </Typography>
      <IconButton
        sx={{
          float: "right",
        }}
        onClick={onRemove}
      >
        <RemoveCircleOutlineIcon
          sx={{
            color: "red",
          }}
        />
      </IconButton>
    </Card>
  );
}
